import { Component, Input } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "vw-link",
  templateUrl: "./link.component.html",
})
export class LinkComponent {
  @Input() text?: string;
  @Input() href?: string;
  @Input() icon?: string;
  @Input() regularLink?: boolean;
  @Input() routerLinks?: RouterLink["routerLink"];
  @Input() anchorTagClass?: string;
  @Input() target?: "_self" | "_blank";

  constructor() {}
}
